import { Sparkles } from "lucide-react";

export const PageHero = ({ eyebrow, title, desc, image, alt = "" }) => {
  return (
    <section
      data-testid="page-hero"
      className="relative pt-32 pb-16 md:pt-40 md:pb-20 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img src={image} alt={alt} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0A192F]/95 via-[#0A192F]/80 to-[#00B37E]/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F] via-[#0A192F]/30 to-transparent" />
        <div className="absolute inset-0 tassei-dot-bg opacity-20 mix-blend-overlay" />
        <div className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-[#00B37E]/25 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 md:px-10 text-white">
        {eyebrow && (
          <div
            data-testid="page-hero-eyebrow"
            className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-white/20 bg-white/10 backdrop-blur text-[#7CF0BD] text-xs font-bold uppercase tracking-[0.22em]"
          >
            <Sparkles className="w-3.5 h-3.5" /> {eyebrow}
          </div>
        )}
        <h1
          data-testid="page-hero-title"
          className="mt-5 font-heading font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight max-w-4xl"
        >
          {title}
        </h1>
        {desc && (
          <p className="mt-5 text-lg text-white/85 leading-relaxed max-w-2xl">
            {desc}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageHero;
